import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'
import { normalizeCertificates } from './normalizeCertificates'

const defaultTraining = {
	nazwa: '',
	certificates: [],
	requiredCertificationIds: [],
	selectedTrainerIds: [],
	location: '',
	ulica: '',
	miasto: '',
	kod_pocztowy: '',
	g_placeid: '',
	g_lat: '',
	g_long: '',
	status: 'new',
	data_rozpoczecia: moment().format('YYYY-MM-DD'),
	data_zakonczenia: moment().format('YYYY-MM-DD'),
	startTime: '',
	endTime: '',
	trainerCompensation: [],
	content: [],
	remarks: '',
}

const normalizeContent = value => {
	if (!Array.isArray(value)) return []

	return value
		.map(item => {
			if (typeof item === 'string') return item.trim()
			return `${item?.name ?? item?.value ?? item?.label ?? ''}`.trim()
		})
		.filter(Boolean)
}

export default function useTrainingFormState(initialData) {
	const [form, setForm] = useState(defaultTraining)

	useEffect(() => {
		const normalized = {
			...defaultTraining,
			...(initialData || {}),
		}

		normalized.certificates = normalizeCertificates(initialData?.certificates)
		if (!normalized.certificates.length && Array.isArray(initialData?.requiredCertificationIds)) {
			normalized.certificates = initialData.requiredCertificationIds
				.filter(Boolean)
				.map(certificateId => ({
					certificateId: String(certificateId),
					certificateName: '',
				}))
		}
		normalized.requiredCertificationIds = normalized.certificates.map(item => item.certificateId)
		normalized.selectedTrainerIds = Array.isArray(initialData?.selectedTrainerIds)
			? initialData.selectedTrainerIds
			: []
		normalized.trainerCompensation = Array.isArray(initialData?.trainerCompensation)
			? initialData.trainerCompensation.map(item => ({
				trainerName: item.trainerName || '',
				hourlyRateGross: item.hourlyRateGross || '',
				extraAmountGross: item.extraAmountGross || '',
			}))
			: []
		normalized.nazwa = normalized.nazwa || normalized.trainingName || ''
		const rawStartDate = normalized.data_rozpoczecia || normalized.trainingDate
		const rawEndDate = normalized.data_zakonczenia || normalized.trainingEndDate || rawStartDate
		normalized.data_rozpoczecia = moment(rawStartDate).isValid()
			? moment(rawStartDate).format('YYYY-MM-DD')
			: moment().format('YYYY-MM-DD')
		normalized.data_zakonczenia = moment(rawEndDate).isValid()
			? moment(rawEndDate).format('YYYY-MM-DD')
			: normalized.data_rozpoczecia
		normalized.startTime = normalized.startTime || normalized.godzina_rozpoczecia || ''
		normalized.endTime = normalized.endTime || normalized.godzina_zakonczenia || ''
		normalized.content = normalizeContent(initialData?.content)
		normalized.remarks = normalized.remarks || normalized.uwagi || ''
		normalized.ulica = normalized.ulica || normalized.adres || normalized.location || ''
		normalized.miasto = normalized.miasto || ''
		normalized.kod_pocztowy = normalized.kod_pocztowy || ''
		normalized.g_placeid = normalized.g_placeid || ''
		normalized.g_lat = normalized.g_lat ?? ''
		normalized.g_long = normalized.g_long ?? ''

		setForm(normalized)
	}, [initialData])

	const setField = useCallback((field, value) => {
		setForm(prev => ({ ...prev, [field]: value }))
	}, [])

	return {
		form,
		setForm,
		setField,
	}
}
